import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import "react-quill/dist/quill.snow.css";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import sweetalert2 from "sweetalert2";
import { useNavigate } from "react-router-dom";
import JoditEditor from 'jodit-react';
import { getTags, createCommonTemplet } from "../../../ReduxStore/Slice/Templets/QuotesTemplets";
import { EMPTY_TEMPLET_NAME_ERROR, EMPTY_TEMPLET_BODY_ERROR } from "../../../Utils/Common_Error";
import axios from 'axios';
import * as Config from "../../../Utils/Config";
const AddCommonTemplet = () => {

  const editor = useRef(null);
  const [editorReady, setEditorReady] = useState(false);
  const [content, setContent] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const [error, setError] = useState({});
  const [activeTab, setActiveTab] = useState("Client");
  const [getTagsData, setTagsData] = useState({
    client: [],
    practice: [],
    user_profile: [],
    others: [],
  });

  const [formData, setFormData] = useState({
    templateName: "",
    body: "",
  });


  useEffect(() => {
    Tags();
  }, []);


  const UpdateFormBody = useCallback((value) => {
    setFormData((prev) => {
      let updatedBody = prev.body.trim();

      const imgTag = `<img src="${value}" width="252" height="160" style="display: inline-block; margin-left: 5px; vertical-align: middle;"/>`;

      if (updatedBody.endsWith("<br>") || updatedBody.endsWith("</p>")) {
        updatedBody = updatedBody.replace(/(<br>|<\/p>)+$/, "");
      }

      updatedBody += ` ${imgTag}`;

      return { ...prev, body: updatedBody };
    });
  }, []);





  // 1) Word HTML cleaner
  const cleanWordHtml = (html = "") => {
    if (!html) return html;

    // <style> blocks
    html = html.replace(/<style[\s\S]*?<\/style>/gi, "");
    // HTML comments
    html = html.replace(/<!--[\s\S]*?-->/g, "");
    // mso- properties (MS Word junk)
    html = html.replace(/mso-[a-z\-]+\s*:[^;"]+(;|")/gi, "");
    // <o:p> tags
    html = html.replace(/<o:p>\s*<\/o:p>|<o:p>.*?<\/o:p>/gi, "");

    return html;
  };



  // 2) Image insert at cursor (NOT at end)
  const UpdateFormBody_Config1 = useCallback((value) => {
    if (editor.current && editor.current.selection) {
      const imgTag = `<img src="${value}" width="252" height="160" style="display:inline-block;margin:5px;vertical-align:middle;">`;
      editor.current.selection.insertHTML(imgTag);
    }
  }, []);


  // 3) Jodit config
  const config1 = useMemo(
    () => ({
     readonly: false,
        placeholder: "",
        buttons:
          "bold,italic,underline,strikethrough,ul,ol,paragraph,fontsize,indent,outdent,font,brush,link,image,video,table,align,undo,redo,cut,copy,paste,selectall,source",
        removeButtons: ["speechRecognize"],
        toolbarSticky: false,
    
        style: {
          font: '14px "Times New Roman", Arial, sans-serif',
          color: "#000000",
          lineHeight: "1.4",
        },
    
        controls: {
          font: {
            list: {
              Poppins: '"Poppins", sans-serif',
              Arial: "Arial, Helvetica, sans-serif",
              "Times New Roman": '"Times New Roman", Times, serif',
              Roboto: "Roboto, sans-serif",
              Verdana: "Verdana, Geneva, sans-serif",
            },
          },
        },
    
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        defaultActionOnPaste: "insert_clear_html",
        defaultActionOnPasteFromWord: "insert_clear_html",
    
        processPasteHTML: (html) => {
          return cleanWordHtml(html);
        },
    
        processPasteFromWord: (html) => {
          return cleanWordHtml(html);
        },
    
        uploader: {
          url: Config.base_url + "img/uploader",
          accept: "image/*,video/*",
          method: "POST",
          withCredentials: false,
          prepareData: async (formData1) => {
            const data = new FormData();
            formData1.forEach((file) => {
              data.append("files[0]", file);
            });
    

          try {
            const response = await axios.post(
              Config.base_url + "img/uploader",
              data,
              { headers: { "Content-Type": "multipart/form-data" } }
            );

            if (response?.data?.files?.[0]) {
              // 👇 cursor par image insert
              UpdateFormBody_Config1(response.data.files[0]);

              return {
                success: true,
                files: response.data.files,
                messages:
                  response.data.messages || ["Image uploaded successfully"],
              };
            }

            return {
              success: false,
              files: [],
              messages: ["Image upload failed"],
            };
          } catch (error) {
            console.error("Image upload error:", error);
            return {
              success: false,
              files: [],
              messages: ["Image upload failed"],
            };
          }
        },

        defaultHandlerSuccess: (resp) => resp?.files ?? [],
        defaultHandlerError: (error) => {
          console.error("Image upload error:", error);
          return [];
        },
      },

      events: {
        afterInit: (editorInstance) => {
          setEditorReady(true);
          editor.current = editorInstance;
        },
      },

      // optional: list style decimal hi rakho
      style: {
        ol: { "list-style-type": "decimal" },
        "ol ol": { "list-style-type": "decimal" },
      },
    }),
    [UpdateFormBody_Config1]
  );



  const Tags = async () => {
    const req = { agent_id: agent_id };
    await dispatch(getTags(req))
      .unwrap()
      .then((res) => {
        if (res.status) {
          const filterClient = res.data.filter((data) => data.type == "client");
          const filterPractice = res.data.filter(
            (data) => data.type == "practice"
          );
          const filterUserProfile = res.data.filter(
            (data) => data.type == "user_profile"
          );
          const filterOther = res.data.filter(
            (data) => data.type == "other" && data.name != "services"
          )

          setTagsData({
            client: filterClient,
            practice: filterPractice,
            user_profile: filterUserProfile,
            others: filterOther
          });
        } else {
          setTagsData({ client: [], practice: [], user_profile: [], others: [] });
        }
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };

  const handleAddTemplate = async () => {
    if (!validateAllFields()) {
      return;
    }

    sweetalert2.fire({
      title: "Are you sure?",
      text: "You want to create this common template?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, create it!",
      cancelButtonText: "No, cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const user_id = JSON.parse(localStorage.getItem("details")).id;
        const req = { name: formData.templateName, body: formData.body, agent_id: agent_id, user_id: user_id }
        await dispatch(createCommonTemplet(req)).unwrap()
          .then((res) => {
            if (res.status) {
              sweetalert2.fire({
                title: 'Success',
                text: res.message,
                icon: 'success',
                confirmButtonText: 'OK',
                timer: 3000,
                timerProgressBar: true
              }).then(() => {
                navigate('/admin/template/all-common-template')
              })
            }
            else {
              sweetalert2.fire({
                title: 'Error',
                text: res.message,
                icon: 'error',
                confirmButtonText: 'OK',
                timer: 3000,
                timerProgressBar: true
              })
            }
          })
          .catch((err) => {
            console.log("Error", err)
          })
      }
    });
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    validate(name, value);
  };

  const validateAllFields = () => {
    let isValid = true;
    for (const key in formData) {
      if (!validate(key, formData[key])) {
        isValid = false;
      }
    }
    return isValid;
  };

  const deleteErrorMsg = (name) => {
    setError((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[name];
      return updatedErrors;
    });
  };

  const validate = (name, value) => {
    const newErrors = { ...error };
    if (!value) {
      switch (name) {
        case "templateName":
          newErrors.templateName = EMPTY_TEMPLET_NAME_ERROR;
          break;
        case "body":
          newErrors.body = EMPTY_TEMPLET_BODY_ERROR;
        default:
          break;
      }
    } else {
      delete newErrors[name];
      deleteErrorMsg(name);
    }

    if (Object.keys(newErrors).length !== 0) {
      setError((prevErrors) => ({
        ...prevErrors,
        ...newErrors,
      }));
    }

    return Object.keys(newErrors).length === 0;
  };

  const insertTag = (tag) => {
    if (editorReady && editor.current) {
      const editorInstance = editor.current;
      if (editorInstance && editorInstance.selection) {
        editorInstance.selection.insertHTML(`{{${tag?.name?.toUpperCase()}}}\t\t`);
      }
    }
  };


  const tags = [
    { id: "Client", name: "Client", },
    { id: "Practice", name: "Practice", },
    { id: "User_Profile", name: "User Profile", },
    { id: "others", name: "Others", },
  ]


  return (
    <div>
      <div className="row mb-3">
        <div className="col">
          <h4 className="page-title">
            <Link to="/admin/template/all-common-template">
              <i className="bx bx-arrow-back text-pink pe-1"></i>
            </Link>
            Create Template
          </h4>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col-md-8">
          <div className="card">
            <div className="card-body tempaltes">
              <div className=" needs-validation">
                <div className="row mb-4">
                  <div className="col-md-12 mb-3">
                    <div className="row">
                      <label
                        htmlFor="inputEmail3"
                        className="col-sm-3 col-form-label"
                      >
                        Template name:
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          name="templateName"
                          onChange={handleInputChange}
                          value={formData.templateName}
                        />
                        {error.templateName && (
                          <div className="error-text">
                            {error.templateName}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="row">
                      <label className="col-sm-12 col-form-label">Body:</label>
                      <div className="col-sm-12">
                        <JoditEditor
                          ref={editor}
                          config={config1}
                          tabIndex={1}
                          onBlur={(newContent) => setContent(newContent)}
                          name="body"
                          onChange={(value) => {
                            setFormData({ ...formData, body: value });
                            validate("body", value);
                          }}
                          value={formData.body || ""}
                        />
                        {error.body && (
                          <div className="error-text">{error.body}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" col-auto text-end">
                  <button
                    className="btn btn-outline-secondary rounded"
                    onClick={() =>
                      navigate("/admin/template/all-common-template")
                    }
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-pink rounded ms-2"
                    onClick={handleAddTemplate}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="quill-editor-full"></div>
        </div>
        <div className="col-md-4">
          <div className="card pt-3 px-2 sticky-card">
            <h5 className="text-gray">
              Tag Provision <i className="bx bx-info-circle text-pink"></i>
            </h5>
            <ul className="nav nav-tabs nav-tabs-bordered d-flex" role="tablist">
              {tags.map((tag) => (
                <li className="nav-item flex-fill" role="presentation" key={tag.id}>
                  <button
                    className={`nav-link ${activeTab === tag.id ? "active" : ""}`}
                    id={tag.id}
                    data-bs-toggle="tab"
                    data-bs-target={`#tab-${tag.id}`}
                    type="button"
                    role="tab"
                    aria-controls={`tab-${tag.id}`}
                    aria-selected={activeTab === tag.id}
                    onClick={() => setActiveTab(tag.id)}
                  >
                    {tag.name}
                  </button>
                </li>
              ))}
            </ul>
            <div className="tab-content p-3">
              {/* Client Tab */}
              <div
                className={`tab-pane fade ${activeTab === "Client" ? "show active" : ""}`}
                id="tab-Client"
                role="tabpanel"
                aria-labelledby="Client"
              >
                <div className="tag-buttons">
                  {getTagsData.client.map((tag) => (
                    <button key={tag.id} onClick={() => insertTag(tag)} className="tag-btn">
                      {"+ " + (tag?.name === "clientCompanyDirectorAddress" ? "DirectorAddress".toUpperCase() :
                        tag?.name?.toUpperCase())}
                    </button>
                  ))}
                </div>
              </div>

              {/* Practice Tab */}
              <div
                className={`tab-pane fade ${activeTab === "Practice" ? "show active" : ""}`}
                id="tab-Practice"
                role="tabpanel"
                aria-labelledby="Practice"
              >
                <div className="tag-buttons">
                  {getTagsData.practice.map((tag) => (
                    <button key={tag.id} onClick={() => insertTag(tag)} className="tag-btn">
                      {"+ " + (tag?.name === "company_name" ? "AccountantCompanyName".toUpperCase() :
                        tag?.name === "incorporated_in" ? "AccountantCompanyIncorporatedIn".toUpperCase() :
                          tag?.name === "company_no" ? "AccountantCompanyRegNumber".toUpperCase() :
                            tag?.name === "agent_registered_address" ? "AccountantCompanyRegAddress".toUpperCase() :
                              tag?.name === "name_of_the_affiliated_accouting_body" ? "NameOfTheAffiliatedAccountingBody".toUpperCase() :

                                tag?.name?.toUpperCase())}
                    </button>
                  ))}
                </div>
              </div>

              <div
                className={`tab-pane fade ${activeTab === "User_Profile" ? "show active" : ""}`}
                id="tab-User_Profile"
                role="tabpanel"
                aria-labelledby="User_Profile"
              >
                <div className="tag-buttons">
                  {getTagsData.user_profile.map((tag) => (
                    <button key={tag.id} onClick={() => insertTag(tag)} className="tag-btn">
                      {"+ " + tag?.name?.toUpperCase()}
                    </button>
                  ))}
                </div>
              </div>
              <div
                className={`tab-pane fade ${activeTab === "others" ? "show active" : ""}`}
                id="tab-Others"
                role="tabpanel"
                aria-labelledby="Others"
              >
                <div className="tag-buttons">
                  {getTagsData.others?.map((tag) => (
                    <button key={tag.id} onClick={() => insertTag(tag)} className="tag-btn">
                      {"+ " + tag?.name?.toUpperCase()}
                    </button>
                  )) || <p>No tags available.</p>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCommonTemplet;
